import React, { useState } from "react";
import WelcomePage from "./components/WelcomePage";
import ReportFunnel from "./components/ReportFunnel";

function App() {
  const [showFunnel, setShowFunnel] = useState(false);

  return (
    <>
      {showFunnel ? (
        <ReportFunnel />
      ) : (
        <WelcomePage onGetStarted={() => setShowFunnel(true)} />
      )}
    </>
  );
}

export default App;
